<div>
    <div class="inner-container-wrapper">
        <div class="titletext error-msg">
            {{'RESET_PASSWORD.PASSWORD_LINK_EXPIRE' | translate}}
        </div>
        <div class="pt48">
            <button class="cp-btn cp-btn-primary" (click)="helperService.goToOnlineBankingApp()"> {{'RESET_PASSWORD.BTN_RESTORE_PASSWORD' | translate}} </button>
        </div>
    </div>
</div>